import request from './index'

// 获取分类信息列表
export function getInfoList(data) {
	return request({
		url: '/cms/web/getCMSBaseListToWebPageByCategoryId',
		method: 'post',
		data
	})
}

// 获取信息详情
export function getInfoDetail(data) {
	return request({
		url: '/cms/web/getCMSDetail',
		method: 'post',
		data
	})
}




// 发布信息
export function publishInfo(data) {
	return request({
		url: '/cms/app/content/publishFromApp',
		method: 'post',
		data
	})
}




// 修改信息
export function updateInfo(id, data) {
	return request({
		url: `/info/update/${id}`,
		method: 'put',
		data
	})
}



// 删除信息
export function deleteInfo(id) {
	return request({
		url: `/info/delete/${id}`,
		method: 'delete'
	})
}




// 创建二维码支付的订单
export function createNativeOrder(data) {
	return request({
		url: '/cms/app/order/createNativeOrder',
		method: 'post',
		data
	})
}




// 信息列表
export function getCMSList(data) {
	return request({
		url: '/cms/web/getCMSBaseListToWebPageByTenant',
		method: 'post',
		data
	})
}